import { Box, Heading, Text, Flex } from "@chakra-ui/react";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getBankRequest,
  getCardsRequest,
  getUserRequest,
} from "store/user/reducer";
import { isLoadingUserSelector } from "store/user/selector";
import { getLoggedInUser } from "network/helper";
import CustomerProfileDetailsForm from "../components/CustomerProfileDetails";
import CustomerProfileMenu from "../components/CustomerProfileMenu";
import { customerProfileMenu } from "../variables/profileMenu";
import IndividualTeam from "../components/team/IndividualTeam";
import Billing from "../components/billing/Billing";
import { useState } from "react";
import PageLayout from "components/layout/PageLayout";
import AppSpinner from "components/spinner/AppSpinner";

export default function AccountDetailsPage() {
  const dispatch = useDispatch();
  const isUserFetching = useSelector(isLoadingUserSelector);
  const user = getLoggedInUser();
  const [selectMenu, setSelectMenu] = useState(customerProfileMenu[0]);

  const headerContent = useMemo(() => {
    if (selectMenu?.link === "billing-reports") {
      return {
        title: "Billing and reports",
        description:
          "Manage your payment methods and access your expense reports.",
      };
    }

    if (selectMenu?.link === "team") {
      return {
        title: "Team Members",
        description:
          "Manage your team members and their access levels.",
      };
    }

    return {
      title: "Account details",
      description:
        "Manage your personal information, update contact details, or change your password.",
    };
  }, [selectMenu?.link]);

  useEffect(() => {
    if (user?.user_id) {
      dispatch(
        getUserRequest({
          user_id: user.user_id,
        })
      );

      dispatch(getCardsRequest({ user_id: user.user_id }));
      dispatch(getBankRequest({ user_id: user.user_id }));
    }
  }, [user?.user_id, dispatch]);

  if (isUserFetching) {
    return (
      <Box maxW="1048px" mx="0" p="40px 20px" textAlign="left">
        <Flex justify="center" align="center" minH="400px">
          <AppSpinner />
        </Flex>
      </Box>
    );
  }

  return (
    <PageLayout>
      <Box maxW="1048px" mx="0" textAlign="left">
        <Heading
          fontSize="24px"
          fontWeight="600"
          color="#1F2937"
          mb="4px"
        >
          {headerContent.title}
        </Heading>
        <Text
          fontSize="16px"
          color="#0B0E10"
          mb="24px"
        >
          {headerContent.description}
        </Text>

        <CustomerProfileMenu
          selectedMenuItem={selectMenu}
          onMenuItemClick={(e: any) => setSelectMenu(e)}
        />

        {selectMenu.link === "account-details" && <CustomerProfileDetailsForm />}
        {selectMenu.link === "team" && <IndividualTeam />}
        {selectMenu.link === "billing-reports" && <Billing />}
      </Box>
    </PageLayout>
  );
}
